var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "panoramas panoramas-radius" },
    [
      _c("i-repeat", {
        attrs: { items: _vm.panoramasList },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ item: panorama }) {
              return [
                _c(
                  "div",
                  { staticClass: "panorama" },
                  [
                    _c("i-favorite", {
                      attrs: {
                        category: "panorama",
                        small: "",
                        item: panorama,
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "panoramas-list-a",
                        class: {
                          active:
                            _vm.hoveredPanorama.objectId === panorama.objectId,
                          "icon-disabled": panorama.disabled,
                          "panoramas-list-a--active": panorama.isActive,
                          disabled: panorama.disabled,
                        },
                        attrs: { disabled: panorama.disabled },
                        on: {
                          mouseenter: function ($event) {
                            return _vm.setHoveredPanorama(panorama)
                          },
                          mouseleave: function ($event) {
                            return _vm.setHoveredPanorama({})
                          },
                          click: function ($event) {
                            $event.preventDefault()
                            return panorama.method.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "panoramas-list-icon",
                            class: [
                              { "icon-active": panorama.isActive },
                              panorama.className,
                            ],
                          },
                          [
                            _c("img", {
                              attrs: { loading: "lazy", src: panorama.image },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "panoramas-list-text" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.multiLangValue(panorama)) +
                              "\n          "
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }